var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersoncropcirclefill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.543 31.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "sf-phone-person-crop-circle-fill-cut0",
    maskUnits: "userSpaceOnUse",
    x: -100,
    y: -100,
    width: 300,
    height: 300
  }, /*#__PURE__*/React.createElement("rect", {
    x: -100,
    y: -100,
    width: 300,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.762 28.887C12.422 28.887 8.906 27.539 6.523 25.039C8.164 22.48 11.66 21.016 15.762 21.016C19.805 21.016 23.34 22.461 25 25.039C22.617 27.539 19.102 28.887 15.762 28.887ZM15.762 18.437C12.812 18.398 10.488 15.957 10.488 12.656C10.469 9.551 12.812 6.992 15.762 6.992C18.711 6.992 21.035 9.551 21.035 12.656C21.035 15.957 18.711 18.477 15.762 18.437Z",
    fill: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sf-phone-person-crop-circle-fill-cut0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.762 31.523C24.473 31.523 31.543 24.453 31.543 15.762C31.543 7.07 24.473 0 15.762 0C7.07 0 0 7.07 0 15.762C0 24.453 7.07 31.523 15.762 31.523Z",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersoncropcirclefill);
export default __webpack_public_path__ + "static/media/person.crop.circle.fill.b40def3a8eedd3cc33249b31f1d82670.svg";
export { ForwardRef as ReactComponent };